import Header from './components/Header';
import Hero from './components/Hero';
import Faq from './components/Faq';
import About from './components/About';
import IndexSection from './components/IndexSection';
import Topics from './components/Topics';
import Comments from './components/Comments';
import AppSection from './components/AppSection';
import Features from './components/Features';
import Cards from './components/Cards';
import Ranking from './components/Ranking';
import Contact from './components/Contact';
import Updates from './components/Updates';
import Carousel from './components/Carousel';
import Media from './components/Media';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Faq />
        <About />
        <IndexSection />
        <Topics />
        <Comments />
        <AppSection />
        <Features />
        <Cards />
        <Ranking />
        <Contact />
        <Updates />
        <Carousel />
        <Media />
      </main>
      <Footer />
    </>
  );
}